import { createIsomorphicFn } from "@tanstack/react-start"
import { setResponseStatus } from "@tanstack/react-start/server"

import { pageNotFoundMeta } from "@/components/feedback/page-not-found"
import { layoutMeta, type HeadMeta } from "@/lib/metadata"

/**
 * A 404's head as Next wrote it: `pageNotFoundMetadata`. (Next also added a
 * bare `robots: noindex`; the router keeps one tag per name, and
 * "noindex, nofollow" already says it.) Inside the site layout
 * (a `notFound()` from a page) the layout's tags come too; the unknown-URL
 * 404 (`global-not-found.tsx`) had none of them.
 */
export function notFoundHead({ layout }: { layout: boolean }): {
  meta: HeadMeta[]
} {
  return {
    meta: [...(layout ? layoutMeta() : []), ...pageNotFoundMeta],
  }
}

/** The unknown-URL page answers 404 (the client has nothing to set). */
export const respondNotFound = createIsomorphicFn()
  .server(() => setResponseStatus(404))
  .client(() => {})
